import React, { useState } from "react";
import api from "../../../api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await api.post("/auth/login", { email, password });

      const response = await api.get("/auth/me");
      const loggedUser = response.data;

      if (!loggedUser.isAdmin) {
        toast.error("Accès refusé : vous n'êtes pas administrateur.");
        setError("Accès refusé : vous n'êtes pas administrateur.");
        return;
      }

      login(loggedUser);
      navigate("/dashboard");
    } catch (err) {
      console.error(err);

      if (err.response?.status === 401) {
        toast.error("Identifiants invalides.");
        setError("Identifiants invalides.");
      } else {
        toast.error("Erreur de connexion.");
        setError("Erreur de connexion.");
      }
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow-md w-full max-w-sm"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">Connexion</h2>

        {error && <p className="mb-4 text-red-500">{error}</p>}

        <div className="mb-4">
          <label htmlFor="email" className="block text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-blue-300"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="password" className="block text-gray-700 mb-2">
            Mot de passe
          </label>
          <input
            type="password"
            id="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-blue-300"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition-colors"
        >
          Se connecter
        </button>
      </form>

      <ToastContainer />
    </div>
  );
}

export default Login;